var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalculator(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_120:7369",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 1,
    width: 17,
    height: 22
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.832 22H6.568C6.15238 21.9992 5.75402 21.8338 5.46013 21.5399C5.16625 21.246 5.00079 20.8476 5 20.432V3.568C5.00079 3.15238 5.16625 2.75402 5.46013 2.46013C5.75402 2.16625 6.15238 2.00079 6.568 2H17.832C18.2476 2.00079 18.646 2.16625 18.9399 2.46013C19.2338 2.75402 19.3992 3.15238 19.4 3.568V20.432C19.3992 20.8476 19.2338 21.246 18.9399 21.5399C18.646 21.8338 18.2476 21.9992 17.832 22V22Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4 8.3999H5",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2002 15.1919V18.3519",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1999 12.7519C16.6417 12.7519 16.9999 12.3937 16.9999 11.9519C16.9999 11.51 16.6417 11.1519 16.1999 11.1519C15.7581 11.1519 15.3999 11.51 15.3999 11.9519C15.3999 12.3937 15.7581 12.7519 16.1999 12.7519Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.1999 12.7519C8.64173 12.7519 8.9999 12.3937 8.9999 11.9519C8.9999 11.51 8.64173 11.1519 8.1999 11.1519C7.75807 11.1519 7.3999 11.51 7.3999 11.9519C7.3999 12.3937 7.75807 12.7519 8.1999 12.7519Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1999 12.7519C12.6417 12.7519 12.9999 12.3937 12.9999 11.9519C12.9999 11.51 12.6417 11.1519 12.1999 11.1519C11.7581 11.1519 11.3999 11.51 11.3999 11.9519C11.3999 12.3937 11.7581 12.7519 12.1999 12.7519Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1999 15.9921C12.6417 15.9921 12.9999 15.6339 12.9999 15.1921C12.9999 14.7503 12.6417 14.3921 12.1999 14.3921C11.7581 14.3921 11.3999 14.7503 11.3999 15.1921C11.3999 15.6339 11.7581 15.9921 12.1999 15.9921Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M8.1999 15.9921C8.64173 15.9921 8.9999 15.6339 8.9999 15.1921C8.9999 14.7503 8.64173 14.3921 8.1999 14.3921C7.75807 14.3921 7.3999 14.7503 7.3999 15.1921C7.3999 15.6339 7.75807 15.9921 8.1999 15.9921Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1999 19.1518C12.6417 19.1518 12.9999 18.7936 12.9999 18.3518C12.9999 17.9099 12.6417 17.5518 12.1999 17.5518C11.7581 17.5518 11.3999 17.9099 11.3999 18.3518C11.3999 18.7936 11.7581 19.1518 12.1999 19.1518Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M8.1999 19.1518C8.64173 19.1518 8.9999 18.7936 8.9999 18.3518C8.9999 17.9099 8.64173 17.5518 8.1999 17.5518C7.75807 17.5518 7.3999 17.9099 7.3999 18.3518C7.3999 18.7936 7.75807 19.1518 8.1999 19.1518Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_120:7369)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#00233B"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalculator);
export default __webpack_public_path__ + "static/media/calculator.b6b00795.svg";
export { ForwardRef as ReactComponent };